import commonFun from "../lib/commonFun";

export const doLogin = (formData) => {
  return commonFun.postProxy('admin/system/login/doLogin',formData)
}

export const loginOut = () => {
  return commonFun.postProxy('admin/system/login/logout', {})
}

// 新增：切换账号调用后端接口（传 uid）
export const doSwitchAccount = (uid) => {
  return commonFun.postProxy('admin/system/login/switchAccount', { uid })
}
